import { useEffect, useRef } from 'react';

const useEffectAfterMount = (effect: () => void | (() => void), deps: any[] | React.DependencyList) => {
  const isMounted = useRef(false);

  useEffect(() => {
    let cleanup: (() => void) | void;

    if (isMounted.current) {
      cleanup = effect();
    } else {
      isMounted.current = true;
    }

    return () => {
      if (cleanup) {
        cleanup();
      }
    };
  }, deps);
};

export default useEffectAfterMount;
